import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { WordAutocomplete } from "@src/components/WordAutocomplete";
import { apiDepotSearch } from "@src/apis/depot-search";
import { useAppStore } from "@src/AppStore";

type Option = { label: string; value: string };

const FixedOption: Option = { label: "All Depots", value: "__region__" };

interface DepotPayrollAutocompleteProps {
  selectedItem: Option;
  onSelect: (item: Option) => void;
}

const DepotPayrollAutocomplete: React.FC<DepotPayrollAutocompleteProps> = ({ selectedItem, onSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState<Option[]>([]);
  const { regionId } = useAppStore();

  useEffect(() => {
    let isMounted = true;

    const loadDepots = async () => {
      try {
        const res = await apiDepotSearch({ query: "%", isDepotPayrole: true });
        const results = res.data?.depots || [];

		const filtered = results.filter((d: any) => d.regionId === regionId);

        if (isMounted) {
          setOptions(
            filtered.map((d: any) => ({
              label: d.name,
              value: d.id,
            }))
          );
        }
      } catch (err) {
        console.error("Failed to fetch depot payrolls", err);
      }
    };

    loadDepots();
    return () => {
      isMounted = false;
    };
  }, [regionId]);

  const filteredOptions: Option[] = [FixedOption, ...options.filter((opt) => (opt.label || "").toLowerCase().includes(inputValue.toLowerCase()))];

  const handleInput = (val: string) => {
    setInputValue(val);
  };

  const handleSelect = (item: Option) => {
    if (item.value === "__region__") {
      setInputValue("");
    } else {
      setInputValue(item.label);
    }
    onSelect(item);
  };

  return <StyledAutocomplete id="depot-payroll-autocomplete" selectedItem={selectedItem} options={filteredOptions} onInput={handleInput} onSelect={handleSelect} color="boral-light" />;
};

const StyledAutocomplete = styled(WordAutocomplete)`
  min-width: 250px;
  width: 100%;
`;

export default DepotPayrollAutocomplete;
